const pt = {
  heroEyebrow: "Kito",
  heroTitle: "Leitura digital e bem‑estar cognitivo para todas as idades.",
  heroSubtitle:
    "O Kito transforma tempo de tela em tempo de leitura com experiências interativas, histórias inteligentes e atividades cognitivas alinhadas à rotina de cuidado.",
  heroCtaPrimary: "Baixar o app",
  heroCtaSecondary: "Conhecer a parceria",
  heroBadge: "+2.500 obras",
  productsTitle: "Nossos Produtos",
  productsCaption: "Ecossistema de leitura e experiências digitais",
  aboutTitle: "Sobre o Kito",
  a11y: {
    googlePlay: "Baixar na Google Play",
    appStore: "Baixar na App Store",
  },
  card: {
    kito: {
      description:
        "Histórias interativas, mini livros e leitura com voz alta, com conteúdo em português, inglês e espanhol.",
    },
    games: {
      title: "Kito Games",
    },
  },
  partner: {
    eyebrow: "Parceria estratégica",
    title: "Kito + Acuidar: cuidado, leitura e inovação.",
    description:
      "Unimos tecnologia educacional e a expertise da Acuidar para oferecer uma jornada completa de estímulo cognitivo, leitura e bem‑estar.",
    whiteLabelLabel: "Modelo white-label",
    whiteLabelDescription:
      "Além da experiência padrão do Kito, também entregamos personalização white-label para parceiros que desejam uma identidade própria no login e na jornada inicial do aplicativo.",
    promoTitle: "Imagine a sua marca aqui também",
    promoDescription:
      "Um aplicativo de leitura e atividades cognitivas com a identidade da sua empresa, pronto para ampliar relacionamento, recorrencia e percepção de valor.",
    internalCtaLabel: "Veja o modelo white-label",
    url: "https://www.acuidarbr.com.br/",
    ctaLabel: "Conhecer a Acuidar Brasil",
    secondaryUrl: "https://acuidarriolife.kito.app.br/",
    secondaryCtaLabel: "Landing Page Acuidar Rio Life",
    defaultLabel: "Login padrão Kito",
    whitelabelLabel: "Login white-label",
  },
  standard: {
    title: "O que já vem no Kito para todos os assinantes",
    subtitle:
      "Os recursos principais do app estão disponíveis para todos os usuários com assinatura ativa nos planos Basico, Plus e Premium.",
    plans: ["Basico", "Plus", "Premium"],
    cards: [
      {
        title: "Biblioteca digital",
        description:
          "Acesso ao acervo com mais de 2.500 obras, entre e-books, minibooks e categorias variadas.",
      },
      {
        title: "Leitura interativa",
        description:
          "Histórias interativas, multíplos finais e experiências de leitura mais envolventes para diferentes perfis de público.",
      },
      {
        title: "Recursos inteligentes",
        description:
          "Leitura em voz alta, multi idiomas e agente de IA para perguntas, respostas e descoberta de conteúdo.",
      },
      {
        title: "Experiências autorais",
        description:
          "Criação de histórias, curadoria editorial e uma jornada pensada para leitura recorrente e divertida.",
      },
    ],
  },
  activities: {
    title: "Atividades cognitivas por domínio",
    subtitle:
      "Esse módulo hoje está liberado em projetos e parcerias específicas, como a Acuidar, com foco em estímulo cognitivo por domínio.",
    badge: "Disponível em parcerias selecionadas",
    cards: [
      {
        title: "Raciocínio lógico e matemático",
        description: "Desafios de alta precisão que trabalham resolução de problemas e agilidade numérica.",
        items: [
          "Nonograma",
          "Resta Um",
          "Soma de Números",
          "Operações matemáticas customizadas",
        ],
      },
      {
        title: "Atenção e funções executivas",
        description: "Exercícios para concentração seletiva e planejamento estratégico.",
        items: ["Desafio das Cores", "Damas"],
      },
      {
        title: "Memória e linguagem",
        description: "Atividades focadas em retenção e repertório verbal.",
        items: ["Memória", "Letroso"],
      },
      {
        title: "Percepção visomotora e criatividade",
        description: "Estímulos para coordenação motora fina e processamento visual.",
        items: ["Colorir por Números", "Ligar Pontos", "Quebra‑cabeças (Puzzles)"],
      },
    ],
  },
  features: {
    title: "Funcionalidades do Kito",
    subtitle: "Recursos centrais do app disponíveis para a jornada de leitura e descoberta.",
    items: [
      "E-books",
      "Minibooks",
      "Histórias interativas",
      "Criação de histórias",
      "Agente de IA para perguntas e respostas",
      "Multi idiomas",
      "Leitura em voz alta",
      "Compatível Android",
      "Compatível iOS",
      "Curadoria especializada",
      "Opção de cobranding",
    ],
  },
  download: {
    title: "Baixe o Kito",
    subtitle: "Disponível para Android e iOS.",
  },
};

const en = {
  heroEyebrow: "Kito",
  heroTitle: "Digital reading and cognitive wellness for all ages.",
  heroSubtitle:
    "Kito turns screen time into reading time with interactive experiences, smart stories, and cognitive activities aligned with everyday care.",
  heroCtaPrimary: "Download the app",
  heroCtaSecondary: "Explore the partnership",
  heroBadge: "2,500+ titles",
  productsTitle: "Our Products",
  productsCaption: "Reading ecosystem and digital experiences",
  aboutTitle: "About Kito",
  a11y: {
    googlePlay: "Download on Google Play",
    appStore: "Download on the App Store",
  },
  card: {
    kito: {
      description:
        "Interactive stories, mini books, and read-aloud features with content in Portuguese, English, and Spanish.",
    },
    games: {
      title: "Kito Games",
    },
  },
  partner: {
    eyebrow: "Strategic partnership",
    title: "Kito + Acuidar: care, reading, and innovation.",
    description:
      "We combine educational technology with Acuidar's expertise to offer a complete journey of cognitive stimulation, reading, and wellness.",
    whiteLabelLabel: "White-label model",
    whiteLabelDescription:
      "In addition to the standard Kito experience, we also provide white-label customization for partners that want their own identity in the login and onboarding journey.",
    promoTitle: "Imagine your brand here too",
    promoDescription:
      "A reading and cognitive activities app with your company's identity, ready to expand engagement, recurrence, and perceived value.",
    internalCtaLabel: "See the white-label model",
    url: "https://www.acuidarbr.com.br/",
    ctaLabel: "Visit Acuidar Brasil",
    secondaryUrl: "https://acuidarriolife.kito.app.br/",
    secondaryCtaLabel: "Access Acuidar Rio Life",
    defaultLabel: "Default Kito login",
    whitelabelLabel: "White-label login",
  },
  standard: {
    title: "What every Kito subscriber already gets",
    subtitle:
      "The app's core features are available to all users with an active subscription on the Basic, Plus, and Premium plans.",
    plans: ["Basic", "Plus", "Premium"],
    cards: [
      {
        title: "Digital library",
        description:
          "Access to a catalog with more than 2,500 titles, including e-books, mini books, and multiple categories.",
      },
      {
        title: "Interactive reading",
        description:
          "Interactive stories, multiple endings, and more engaging reading experiences for different audience profiles.",
      },
      {
        title: "Smart features",
        description:
          "Read-aloud, multiple languages, and an AI agent for questions, answers, and content discovery.",
      },
      {
        title: "Creative experiences",
        description:
          "Story creation, editorial curation, and a journey designed for recurring and enjoyable reading.",
      },
    ],
  },
  activities: {
    title: "Cognitive activities by domain",
    subtitle:
      "This module is currently available in selected projects and partnerships, such as Acuidar, with a focus on cognitive stimulation by domain.",
    badge: "Available in selected partnerships",
    cards: [
      {
        title: "Logical and mathematical reasoning",
        description:
          "High-precision challenges that develop problem solving and numerical agility.",
        items: [
          "Nonogram",
          "Peg Solitaire",
          "Number Sum",
          "Custom math operations",
        ],
      },
      {
        title: "Attention and executive functions",
        description:
          "Exercises for selective attention, inhibitory control, and strategic planning.",
        items: ["Color Challenge", "Checkers"],
      },
      {
        title: "Memory and language",
        description:
          "Activities focused on retention and verbal repertoire building.",
        items: ["Memory", "Letroso"],
      },
      {
        title: "Visuomotor perception and creativity",
        description:
          "Stimuli for fine motor coordination and visual processing.",
        items: ["Color by Numbers", "Connect the Dots", "Puzzles"],
      },
    ],
  },
  features: {
    title: "Kito Features",
    subtitle: "Core app resources available for reading and discovery.",
    items: [
      "E-books",
      "Mini books",
      "Interactive stories",
      "Story creation",
      "AI agent for questions and answers",
      "Multiple languages",
      "Read-aloud",
      "Android compatible",
      "iOS compatible",
      "Specialized curation",
      "Co-branding option",
    ],
  },
  download: {
    title: "Download Kito",
    subtitle: "Available for Android and iOS.",
  },
};

const es = {
  heroEyebrow: "Kito",
  heroTitle: "Lectura digital y bienestar cognitivo para todas las edades.",
  heroSubtitle:
    "Kito convierte el tiempo de pantalla en tiempo de lectura con experiencias interactivas, historias inteligentes y actividades cognitivas alineadas con la rutina de cuidado.",
  heroCtaPrimary: "Descargar la app",
  heroCtaSecondary: "Conocer la alianza",
  heroBadge: "+2.500 obras",
  productsTitle: "Nuestros Productos",
  productsCaption: "Ecosistema de lectura y experiencias digitales",
  aboutTitle: "Sobre Kito",
  a11y: {
    googlePlay: "Descargar en Google Play",
    appStore: "Descargar en App Store",
  },
  card: {
    kito: {
      description:
        "Historias interactivas, mini libros y lectura en voz alta con contenido en portugués, inglés y español.",
    },
    games: {
      title: "Kito Games",
    },
  },
  partner: {
    eyebrow: "Alianza estratégica",
    title: "Kito + Acuidar: cuidado, lectura e innovación.",
    description:
      "Unimos tecnología educativa y la experiencia de Acuidar para ofrecer una jornada completa de estimulación cognitiva, lectura y bienestar.",
    whiteLabelLabel: "Modelo white-label",
    whiteLabelDescription:
      "Además de la experiencia estándar de Kito, también ofrecemos personalización white-label para socios que desean una identidad propia en el login y en la experiencia inicial de la app.",
    promoTitle: "Imagina tu marca aqui tambien",
    promoDescription:
      "Una app de lectura y actividades cognitivas con la identidad de tu empresa, lista para ampliar relacion, recurrencia y valor percibido.",
    internalCtaLabel: "Ver el modelo white-label",
    url: "https://www.acuidarbr.com.br/",
    ctaLabel: "Conocer Acuidar Brasil",
    secondaryUrl: "https://acuidarriolife.kito.app.br/",
    secondaryCtaLabel: "Acceder al entorno Acuidar Rio Life",
    defaultLabel: "Login estándar Kito",
    whitelabelLabel: "Login white-label",
  },
  standard: {
    title: "Lo que ya viene con Kito para todos los suscriptores",
    subtitle:
      "Las funciones principales de la app están disponibles para todos los usuarios con suscripción activa en los planes Básico, Plus y Premium.",
    plans: ["Básico", "Plus", "Premium"],
    cards: [
      {
        title: "Biblioteca digital",
        description:
          "Acceso a un catálogo con más de 2.500 obras, entre e-books, mini libros y categorías variadas.",
      },
      {
        title: "Lectura interactiva",
        description:
          "Historias interactivas, múltiples finales y experiencias de lectura más envolventes para diferentes perfiles.",
      },
      {
        title: "Recursos inteligentes",
        description:
          "Lectura en voz alta, varios idiomas y un agente de IA para preguntas, respuestas y descubrimiento de contenido.",
      },
      {
        title: "Experiencias autorales",
        description:
          "Creación de historias, curaduría editorial y una jornada pensada para una lectura recurrente y divertida.",
      },
    ],
  },
  activities: {
    title: "Actividades cognitivas por dominio",
    subtitle:
      "Este módulo actualmente se libera en proyectos y alianzas específicas, como Acuidar, con foco en estimulación cognitiva por dominio.",
    badge: "Disponible en alianzas seleccionadas",
    cards: [
      {
        title: "Razonamiento lógico y matemático",
        description:
          "Desafíos de alta precisión que trabajan la resolución de problemas y la agilidad numérica.",
        items: [
          "Nonograma",
          "Resta Uno",
          "Suma de Números",
          "Operaciones matemáticas personalizadas",
        ],
      },
      {
        title: "Atención y funciones ejecutivas",
        description:
          "Ejercicios para atención selectiva, control inhibitorio y planificación estratégica.",
        items: ["Desafío de los Colores", "Damas"],
      },
      {
        title: "Memoria y lenguaje",
        description:
          "Actividades enfocadas en retención y fortalecimiento del repertorio verbal.",
        items: ["Memoria", "Letroso"],
      },
      {
        title: "Percepción visomotora y creatividad",
        description:
          "Estímulos para coordinación motora fina y procesamiento visual.",
        items: ["Colorear por Números", "Unir Puntos", "Rompecabezas"],
      },
    ],
  },
  features: {
    title: "Funciones de Kito",
    subtitle: "Recursos centrales de la app disponibles para la lectura y el descubrimiento.",
    items: [
      "E-books",
      "Mini libros",
      "Historias interactivas",
      "Creación de historias",
      "Agente de IA para preguntas y respuestas",
      "Varios idiomas",
      "Lectura en voz alta",
      "Compatible con Android",
      "Compatible con iOS",
      "Curaduría especializada",
      "Opción de co-branding",
    ],
  },
  download: {
    title: "Descarga Kito",
    subtitle: "Disponible para Android e iOS.",
  },
};

const homeTranslations = {
  pt,
  en,
  es,
};

export default homeTranslations;
